var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "confirm-main"
  }, [_c('div', {
    staticClass: "confirm-title"
  }, [_c('h1', {
    staticClass: "confirm-text"
  }, [_vm._v(_vm._s(_vm.title || '确认'))]), _vm._v(" "), _c('i', {
    staticClass: "confirm-cancel",
    on: {
      "click": _vm.cancelFn
    }
  }, [_vm._v("x")])]), _vm._v(" "), _c('div', {
    staticClass: "confirm-content"
  }, [_c('label', [_vm._v("\n            请输入："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.text),
      expression: "text"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.text = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "confirm-footer"
  }, [_c('button', {
    staticClass: "confirm-footer-success",
    on: {
      "click": _vm.okFn
    }
  }, [_vm._v(_vm._s(_vm.ok || '确定'))]), _vm._v(" "), _c('button', {
    staticClass: "confirm-footer-default",
    on: {
      "click": _vm.cancelFn
    }
  }, [_vm._v(_vm._s(_vm.cancel || '取消'))])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6dad6c8f","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/input.vue
// module id = kQjP
// module chunks = 1